<!-- 采购申请 -->
<template>
  <div class="my-mad-department p5 m5 bw br5">
    <div class="header-style mb5">
      采购申请
    </div>
    <!--    <search-vue ref="searchVue" :columns="tableSet.columns" :valueSet="valueSet" :onlyKey="'purchaseRequisition'"></search-vue>-->
    <div class="fix">
      <q-input class="w180 l mr10" outlined placeholder="输入采购申请单单号查询" v-model="query.FPRBILLNO" dense square clearable>
        <q-tooltip>采购申请单单号</q-tooltip>
      </q-input>
      <q-input class="w180 l mr10" outlined placeholder="输入订货号查询" v-model="query.MATNR" dense square clearable>
        <q-tooltip>订货号</q-tooltip>
      </q-input>
      <q-input class="w180 l mr10" outlined placeholder="输入规格型号查询" v-model="query.FModel" dense square clearable>
        <q-tooltip>规格型号</q-tooltip>
      </q-input>
      <q-btn size='9px' class="l mr10" color="primary" icon="fas fa-search" @click="search"></q-btn>
      <q-btn size='9px' class="l mr10" icon="fas fa-redo" @click="resetSearch"></q-btn>
    </div>
    <!-- <div>
      <base-table v-if="!tableSet.loading" @tool_click="tool_click" :tableSet="tableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
      <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
    </div> -->
    <div>
      <base-table v-if="!entryTableSet.loading && !tableSet.loading" @tool_click="tool_click" :tableSet="entryTableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
      <q-skeleton :height="entryTableSet.height" v-if="entryTableSet.loading || tableSet.loading" />
    </div>
  </div>
</template>

<script>
import {onMounted, ref,watch} from "vue";
import API from '@/apis/index';
import BaseTable from '@/components/pieces/tables/default-table.vue';
import {useStore} from "vuex";
import {tableHeight} from "@/tools/lines.js";
import {getRandomString} from '@/tools/utils.js'
import {useRouter} from "vue-router";
import searchVue from '@/components/pieces/search/search.vue';
import {isNotEmpty} from "@/tools/utils";
export default {
  name: "index",
  components:{
    BaseTable
  },
  setup(){
    let store = useStore();
    let tab = ref('tjdzt');
    const router = useRouter();
    let valueSet = ref({});
    let formData = ref({
      keys: '',
      Fpp:'',
      Fdhh:'',
      Fxj:'',
      Fmx:'',
    });
    let tableSet =store.getters["purchaseRequisition/getTable"];
    let entryTableSet =store.getters["purchaseRequisition/getEntryTable"];
    let query = ref({
      FPRBILLNO:'',
      FModel:'',
      MATNR:'',
      FBillNoXS:'',
      VBELN:'',
    })
    let changeRowsPage = (value)=>{
      localStorage.setItem("pageSize", value);
      tableSet.pagination.rowsPerPage = value;
      getTableData();
    }
    let changePage = (value)=>{
      tableSet.pagination.page = value;
      getTableData();
    }
    let updateSelected = (data)=>{
      store.dispatch('purchaseRequisition/getSoEntryList')
    }
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("purchaseRequisition/setTableHeight", tableHeight());
    }
    function getParams(){
      let params={
        pagination: {
          rowsPerPage: tableSet.pagination.rowsPerPage,
          page: tableSet.pagination.page,
        },
        query:{
        }
      };
      if(isNotEmpty(query.value.FPRBILLNO)){
        params.query.FPRBILLNO = query.value.FPRBILLNO;
      }
      if(isNotEmpty(query.value.FModel)){
        params.query.FModel = query.value.FModel;
      }
      if(isNotEmpty(query.value.MATNR)){
        params.query.MATNR = query.value.MATNR;
      }
      if(isNotEmpty(query.value.FBillNoXS)){
        params.query.FBillNoXS = query.value.FBillNoXS;
      }
      if(isNotEmpty(query.value.VBELN)){
        params.query.VBELN = query.value.VBELN;
      }
      return params
    }
    function search(){
      tableSet.pagination.page = 1;
      getTableData();
    }
    function resetSearch(){
      query.value = {
        FPRBILLNO:'',
        FModel:'',
        MATNR:'',
        FBillNoXS:'',
        VBELN:'',
      };
      tableSet.pagination.page = 1;
      getTableData();
    }
    function getTableData(){
      let params = getParams();
      store.dispatch("purchaseRequisition/getSoEntryList",params)
    }
    function init(){
      getTableData();
    }
    onMounted(()=>{
      init();
      refreshTableHeight();
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    });
    function tool_click(type){
      if(type == 'createEoder'){
        gotoEoder();
      }
      // if(type == 'showDetails'){
      //   showDetails();
      // }
    }
    function showDetails(){
      router.push({
        name: "purchaseRequisitionDetails",
      });
    }
    function gotoEoder(){
      router.push({
        name: "eorderDetails",
        params:{id:getRandomString()}
      });
    }
    return{
      formData,
      search,
      resetSearch,
      tableSet,
      tool_click,
      tab,
      valueSet,
      changeRowsPage,
      changePage,
      updateSelected,
      entryTableSet,
      query
    }
  },
}
</script>
